const addAjaxPending = function (element) {
  element.classList.add("ajax-pending");
};

const removeAjaxPending = function (element) {
  element.classList.remove("ajax-pending");
};

export { addAjaxPending, removeAjaxPending };
